import { IMessageJobMembersProfile } from "@endpoints/types/message.type";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import ChatList from "./ChatList";

interface ChatSectionProps {
  selectedContact: IMessageJobMembersProfile;
}

const ChatSection = ({ selectedContact }: ChatSectionProps) => {
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get("jobId");

  const selectedJob = useMemo(
    () =>
      selectedContact?.appliedJobs?.find(
        (aj) => (aj.job?._id || aj?.job?.jobId) === jobId
      ),
    [selectedContact]
  );

  console.log('check chat section',selectedJob,jobId)
  return (
    <div className="flex flex-col min-h-0 w-full flex-1">
      {selectedContact && jobId ? (
        <>
          <div className="flex items-start justify-between gap-4 py-3 pl-4 pr-8 bg-white border-b">
            <div className="flex gap-3 items-center">
              <div className="h-9 w-9 rounded-full flex justify-center items-center bg-gray-400">
                {selectedContact?.userDetails?.profilePic ? (
                  <img
                    src={selectedContact?.userDetails.profilePic}
                    className="h-full w-full object-cover rounded-full"
                    alt="Selected Profile"
                  />
                ) : (
                  <div className="text-white font-semibold uppercase text-lg">
                    {selectedContact?.userDetails?.firstName?.charAt(0)}
                  </div>
                )}
              </div>

              <div className="flex flex-col gap-1">
                <p className="text-primary font-bold text-xs">
                  {selectedContact?.userDetails.firstName}{" "}
                  {selectedContact?.userDetails.lastName}
                  <span className="font-medium text-light-black">
                    {" "}
                    - {selectedContact?.userDetails?.companyName}
                  </span>
                </p>
                <p className="text-light-black font-medium text-xs">
                  Rooom title -{" "}
                  <span className="text-primary">
                    {selectedJob?.job?.title}
                  </span>
                </p>
                {/* <p className="text-light-black font-medium text-[11px]">
                      {selectedContact?.userDetails.refNo}
                    </p> */}
              </div>
            </div>
            <p className="text-light-black font-medium text-xs">
              {selectedContact?.userDetails.refNo}
            </p>
          </div>
          <ChatList jobId={jobId} />
        </>
      ) : (
        <div className="flex flex-col flex-1 items-center justify-center font-medium text-sm text-light-black">
          Please select some job chat.
        </div>
      )}
    </div>
  );
};

export default ChatSection;
